interface Props {
    name: string;
    label: string;
    value: boolean;
    onChange: (name: string, value: boolean) => void;
    hidden?: boolean | null;
    disabled?: boolean | null;
}

export default function CheckBoxField({
    name,
    label,
    value,
    onChange,
    hidden = false,
    disabled,
}: Props) {
    return (
        <div className='form-check checked-custom mb-3' key={name} hidden={hidden!}>
            <input
                type='checkbox'
                className='form-check-input'
                checked={value}
                name={name}
                id={name + '_' + value}
                disabled={disabled ?? false}
                onChange={(event) => onChange(name, event.target.checked)}
            />
            <label htmlFor={name + '_' + value} className='form-check-label me-1'>
                {label}
            </label>
        </div>
    );
}
